import { render, staticRenderFns } from "./CertificateEdit.vue?vue&type=template&id=4b60b18a&scoped=true"
import script from "./CertificateEdit.vue?vue&type=script&lang=js"
export * from "./CertificateEdit.vue?vue&type=script&lang=js"
import style0 from "./CertificateEdit.vue?vue&type=style&index=0&id=4b60b18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60b18a",
  null
  
)

export default component.exports